import styled from 'styled-components';

export const StyledSelectV2 = styled.select`
	cursor: text;
	border: 1px solid color-mix(in oklab,#1D1B2620%,#0000);
	appearance: none;
	background-color: ${({ $error }) => $error ? 'rgba(255, 0, 0, 0.1)' : '#FFFFFF'};
	vertical-align: middle;
	white-space: nowrap;
	width: 100%;
	height: 2.5rem;
	touch-action: manipulation;;
	box-shadow: 0 1px color-mix(in oklab,color-mix(in oklab,#1D1B2620%,#0000)calc(0*10%),#0000)inset,0 -1px oklch(100% 0 0/calc(0*.1))inset;
	border-start-start-radius: 0.25em;
	border-start-end-radius: 0.25em;
	border-end-end-radius: 0.25em;
	border-end-start-radius: 0.25em;
	flex-shrink: 1;
	align-items: center;
	gap: .5rem;
	padding-inline: .75rem;
	font-size: .875rem;
	position: relative;
  &:focus, &:focus-within {
    box-shadow: 0 1px color-mix(in oklab,#1D1B26calc(0*10%),#0000);
    outline: 2px solid #1D1B26;
    outline-offset: 2px;
    isolation: isolate;
  }
`;